export enum DeliveryTypeOptions {
  DP = '1dc02d7f-0e62-48a8-b159-02d599af3ceb',
  PD = 'a44d43de-7177-43bf-bd6a-fe7e9cc5b8bb',
  PP = 'a0e7ed32-9b7c-45ce-a1bf-d756077f9489',
  DD = '45f0a156-045a-47a1-b1ad-d42000038482',
}
